export const ADD_SITE = "ADD_SITE"
export const TOGGLE_LANG = "TOGGLE_LANG"
export const OPEN_LANG = "OPEN_LANG"
export const CLOSE_LANG = "CLOSE_LANG"
export const TOGGLE_SEARCH = "TOGGLE_SEARCH"
export const TOGGLE_MENU = "TOGGLE_MENU"
export const TOGGLE_NAV = "TOGGLE_NAV"
